import { useLiveStayDuration } from 'src/hooks/useLiveStayDuration';

type DurationProps = {
    entryTime?: string;
    exitTime?: string;
};
const Duration = ({ entryTime, exitTime }: DurationProps) => {
    const durationToDisplay = useLiveStayDuration(entryTime, exitTime);
    return <div className="text-sm">{durationToDisplay}</div>;
};
export default Duration;
